import React from 'react'

import type {Props as SignupProps} from '@/components/signup-modal'
import {SignupModal} from '@/components/signup-modal'

const SignupModalContext = React.createContext({
    renderSignupModal: (props: SignupProps) => {},
})

export const useSignupModal = () => React.useContext(SignupModalContext)

export const SignupModalProvider = ({children}: {children: React.ReactNode}) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const [modalProps, setModalProps] = React.useState<Omit<SignupProps, 'isOpen'>>({
        title: '',
        formId: '',
        highlightedFeatures: [],
    })

    const renderSignupModal = (props: SignupProps) => {
        setIsModalOpen(!isModalOpen)
        setModalProps(props)
    }

    return (
        <SignupModalContext.Provider value={{renderSignupModal}}>
            <SignupModal
                {...modalProps}
                isOpen={isModalOpen}
                onDismiss={() => {
                    modalProps.onDismiss && modalProps.onDismiss()
                    setIsModalOpen(false)
                }}
            />
            {children}
        </SignupModalContext.Provider>
    )
}
